import template from './snapshot-widget.html';
import controller from './snatpshot-widget.controller';

import './snapshot-widget.styl';

const snapshotWidgetComponent = {
  restrict: 'E',
  bindings: {
      type: '=',
  },
  template,
  controller
};

export default snapshotWidgetComponent;



// WEBPACK FOOTER //
// ./client/app/common/snapshot-widget/snapshot-widget.component.js